module.exports = __webpack_public_path__ + "img/seo-content-collapsible-mitsu.94bc80f7.png";